export { default as Home } from "./Home";
export { default as Register } from "./Register";
export { default as Contact } from "./Contact";
export { default as About } from "./About";
export { default as Links } from "./Links";
export { default as Gardens } from "./Gardens";
